import { useState, useRef, useLayoutEffect } from "react";

import kutil from "@modules/kutil";
import valueFormatter from "@modules/value_formatter";

import { usePopup } from "@components/popup/popup_context";

import { type WorkDetail } from "@user/store/plc_store";

interface Props {
  work: WorkDetail
}

interface State {
  procMethod: string;
}

const defState: State = {
  procMethod: "",
};

export default function WorkManagement(props: Props) {
  const { setOption, setActions, onClose } = usePopup();
  const [state, setState] = useState<State>(kutil.deepCopy(defState));

  const procWorkRef = useRef(procWork);
  procWorkRef.current = procWork;

  const work = props.work;

  useLayoutEffect(() => {
    setOption({
      title: "작업관리",
      maxWidth: "700px"
    });
    setActions([
      {
        id: "closePopup",
        label: "취소",
        className: "basic outline",
        onClick: () => onClose(),
      },
      {
        id: "procWork",
        label: "지시",
        className: "basic fill",
        onClick: () => procWorkRef.current(),
      }
    ]);
  }, []);

  async function procWork() {
    if (!state.procMethod) {
      alert("처리방법을 선택하세요.");
      return;
    }

    if (await kutil.confirm("작업지시를 하시겠습니까?") == false) {
      return false;
    }
    try {
      const reqInfo = {
        workNo: work.workNo,
        procMethod: state.procMethod,
      }
      const data = await kutil.sendPost("/api/work/work_management.proc?mode=" + state.procMethod, reqInfo, {
      });

      await kutil.alert("처리되었습니다.");
      onClose();
    } catch(e) {
      console.log(e);
    }
  }

  return (
    <>
      <div className="popup-contents">
        <div className="table-wrap">
          <table>
            <colgroup>
              <col style={{ width: "33.3%" }} />
              <col style={{ width: "66.6%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">작업번호</th>
                <td>
                  {work.workNoMfc}({work.workNoPlc})
                </td>
              </tr>
              <tr>
                <th scope="row">출발위치</th>
                <td>
                  <div className="select-location">
                    { valueFormatter.location(work.startPos) }
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">도착위치</th>
                <td>
                  <div className="select-location">
                    { valueFormatter.location(work.endPos) }
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">처리방법</th>
                <td>
                  <div className="text-align-ver">
                    <input type="checkbox" id="handling_method00" checked={state.procMethod == "SKIP"} onChange={(e) => setState(prev => ({...prev, procMethod: e.target.checked ? "SKIP" : ""}))} /> <label htmlFor="handling_method00">진행설비 완료</label>
                    <input type="checkbox" id="handling_method01" checked={state.procMethod == "FORCE_DONE"} onChange={(e) => setState(prev => ({...prev, procMethod: e.target.checked ? "FORCE_DONE" : ""}))} /> <label htmlFor="handling_method01">작업 완료</label>
                    <input type="checkbox" id="handling_method02" checked={state.procMethod == "CANCEL"} onChange={(e) => setState(prev => ({...prev, procMethod: e.target.checked ? "CANCEL" : ""}))} /> <label htmlFor="handling_method02">작업 삭제</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
